
import Vue from "vue";
import { mapState } from "vuex";
import AddAdminDialog from "@/components/AddAdminDialog.vue";

export default Vue.extend({
  computed: {
    ...mapState(["data", "admin"]),
  },
  components: {
    AddAdminDialog,
  },
  data: () => ({
    showAddAdminDialog: false,
    showConfirmDialog: false,
    adminToDelete: 0,
    loadingDelete: false,
  }),
  beforeMount() {
    if (!this.data.admins.length) {
      this.$store.dispatch("refreshAdmins");
    }
  },
  methods: {
    showConfirmation(id: number) {
      this.adminToDelete = id;
      this.showConfirmDialog = true;
    },
    hideConfirmation() {
      this.adminToDelete = 0;
    },
    async confirmDeleteAdmin() {
      this.loadingDelete = true;
      this.$store.dispatch("deleteAdmin", this.adminToDelete);
      this.loadingDelete = false;
      this.showConfirmDialog = false;
    },
  },
  watch: {
    showConfirmDialog() {
      if (!this.showConfirmDialog) {
        this.hideConfirmation();
      }
    },
  },
});
